import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import axios from "axios";
// import logger from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
// import {
//   generatingTokenFailed,
//   generatingTokenSuccess,
// } from "./authentication/actions";

import reducers from "./rootReducer";
import API from "../utils/endpoints";
// import { setAuthenticationCookie } from "../utils/authentication";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import {
  getAuthenticationCookie,
  setAuthenticationCookie,
} from "../utils/authentication";
import {
  generatingTokenFailed,
  generatingTokenSuccess,
} from "./authentication/actions";

const axiosInstance = axios.create({
  baseURL: API.baseUrl,
  headers: {
    "x-custom-country": "in",
    "x-custom-language": "en",
  },
});

let middleware = [thunk.withExtraArgument(axiosInstance)];

// if (process.env.NODE_ENV === `development`) {
//   middleware.push(logger);
// }

const enhancers = composeWithDevTools(applyMiddleware(...middleware));
const store = createStore(reducers, enhancers);

axiosInstance.interceptors.request.use(async function(config) {
  const { accessToken } = await getAuthenticationCookie();
  config.headers.Authorization = accessToken ? accessToken : "";
  config.headers.app_id = "1";
  return config;
});

axiosInstance.interceptors.response.use(async function(response) {
  if (
    response.status === 200 &&
    response.data &&
    [401, 402].includes(response.data.code) //401
  ) {
    // Cookies.remove("accessToken");
    // Cookies.remove("refreshToken");
    Cookies.remove("RE_BU_CR");
    window.location.reload();
    toast.error("Session Expired Please Login Again");
    return new Promise(async (resolve, reject) => {
      const originalReq = response.config;

      if (response.config && !response.config.__isRetryRequest) {
        originalReq._retry = true;

        let existingRefreshToken = await store.getState().Auth.refreshToken;
        let guid = await store.getState().Auth.guid;

        let res = axios
          .post(`${API.baseUrl}${API.generateNewToken}`, {
            refreshToken: existingRefreshToken,
            userId: guid,
          })
          .then(async (res) => {
            if (res.data.code === 200) {
              let {
                data: {
                  data: { accessToken, refreshToken },
                },
              } = res;

              await setAuthenticationCookie({
                accessToken,
                refreshToken,
                user: { guid },
              });
              store.dispatch(generatingTokenSuccess(res.data.data));

              originalReq.headers["Authorization"] = accessToken;

              return axios(originalReq);
            }
            await Cookies.remove("RE_BU_CR");

            return store.dispatch(generatingTokenFailed(res.data));
          });

        resolve(res);
      }
      return Promise.reject(response);
    });
  } else {
    return response;
  }
});

export default store;
